<template>
  <v-card>
    <v-card-title>
      <v-flex xs12>
        <div class="headline">Pendências de bancas</div>
      </v-flex>
    </v-card-title>

    <v-card-text v-if="loading"> Carregando pendências... </v-card-text>

    <v-card-text v-if="errors.length">
      <v-alert error value="true" v-for="(error, index) in errors" :key="index">
        {{ error }}
      </v-alert>
    </v-card-text>

    <v-card v-for="pendency in pendencies" :key="pendency.id" class="ma-3">
      <v-card-title>
        <v-flex xs12>
          <strong>Banca {{ pendency.id }} - {{ pendency.title }}</strong
          ><br />
          {{ formatDate(pendency.date) }} · Curso: {{ pendency.courseName }} ·
          Presidente: {{ pendency.chairName }}
        </v-flex>
      </v-card-title>
      <v-card-text
        class="pendency-chips"
        :class="{ 'pendency-chips--active': canOpenActions }"
      >
        <v-chip
          small
          color="warning"
          text-color="white"
          v-if="pendency.finalScorePending"
        >
          <router-link
            v-if="canOpenActions"
            class="white--text"
            :to="{ name: 'examDetail', params: { id: pendency.id } }"
            >Nota pendente</router-link
          >
          <span v-else>Nota pendente</span>
        </v-chip>
        <v-chip
          small
          color="warning"
          text-color="white"
          v-if="pendency.attendancePending"
          @click.stop="canOpenActions && showExamAttendance(pendency.id)"
          :link="canOpenActions"
        >
          Presenças/ausências pendentes
        </v-chip>
        <v-chip
          small
          color="warning"
          text-color="white"
          v-if="pendency.certificationPending"
          @click.stop="canOpenActions && showExamAttendance(pendency.id)"
          :link="canOpenActions"
        >
          Certificações pendentes
        </v-chip>
        <v-chip
          small
          color="warning"
          text-color="white"
          v-if="pendency.minutesPending"
          :class="{'cursor-pointer': canOpenActions}"
          @click.stop="canOpenActions && showExamDocuments(pendency.id)"
        >
          Ata pendente
        </v-chip>
        <v-chip
          small
          color="warning"
          text-color="white"
          v-if="pendency.closingPending"
        >
          <router-link
            v-if="canOpenActions"
            class="white--text"
            :to="{ name: 'examDetail', params: { id: pendency.id } }"
            >Encerramento pendente</router-link
          >
          <span v-else>Encerramento pendente</span>
        </v-chip>
      </v-card-text>
    </v-card>

    <v-card-text v-if="!loading && !errors.length && !pendencies.length">
      Não há bancas com pendências.
    </v-card-text>

    <v-dialog v-model="attendanceDialog" fullscreen lazy>
      <exam-attendance :exam-id="selectedExam">
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="info" @click="attendanceDialog = false">Fechar</v-btn>
        </template>
      </exam-attendance>
    </v-dialog>

    <v-dialog v-model="documentsDialog" fullscreen lazy>
      <exam-documents :exam-id="selectedExam">
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="info" @click="documentsDialog = false">Fechar</v-btn>
        </template>
      </exam-documents>
    </v-dialog>
  </v-card>
</template>

<script>
import auth from "../auth";
import ExamAttendance from "./ExamAttendance.vue";
import ExamDocuments from "./ExamDocuments.vue";
import moment from "moment";

export default {
  name: "ExamPendency",
  components: {
    ExamAttendance,
    ExamDocuments,
  },
  data() {
    return {
      pendencies: [],
      errors: [],
      loading: false,
      selectedExam: null,
      attendanceDialog: false,
      documentsDialog: false,
    };
  },
  computed: {
    canOpenActions() {
      return auth.user.roles.some((role) =>
        ["chair", "examcoordinator", "coursecoordinator", "admin"].includes(
          role
        )
      );
    },
  },
  methods: {
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    loadPendencies() {
      this.loading = true;
      this.errors = [];
      this.$http.post("examPendencies").then(
        (response) => {
          this.pendencies = response.body;
          this.loading = false;
        },
        (response) => {
          this.loading = false;
          this.errors =
            response.body && response.body.errors
              ? response.body.errors
              : ["Erro ao carregar pendências de bancas."];
        }
      );
    },
    showExamAttendance(examId) {
      this.selectedExam = examId;
      this.attendanceDialog = true;
    },
    showExamDocuments(examId) {
      this.selectedExam = examId;
      this.documentsDialog = true;
    },
  },
  created() {
    this.loadPendencies();
  },
};
</script>



// WEBPACK FOOTER //
// ExamPendency.vue?61536ca4